import { Loader } from '@deque/cauldron-react';
import type { ReactElement } from 'react';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { sendOnboardingForm } from '~/common/api-client';
import { useAuthContext } from '~/common/contexts/auth';
import { useGlobalToast } from '~/common/contexts/globalToast';
import OnboardingFormComponent, {
  type OnboardingForm
} from '../components/OnboardingForm';

const OnboardingForm = (): ReactElement => {
  const { user, loading } = useAuthContext();
  const { setContents } = useGlobalToast();
  const { t } = useTranslation();
  const loaderRef = useRef<HTMLDivElement>(null);
  const history = useHistory();

  const [submitting, setSubmitting] = useState(false);

  const onSubmitForm = async (data: OnboardingForm) => {
    try {
      setSubmitting(true);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      await sendOnboardingForm(user!.token, data);
      setContents(
        t(
          'Form was successfully submitted. You should receive your custom implementation documentation in the next 3-5 business days.'
        ),
        'confirmation'
      );
      history.push('/');
    } catch {
      setContents(t('Error sending onboarding form'), 'error');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <Loader label={t('Loading')} tabIndex={-1} ref={loaderRef} />;
  }

  return (
    <OnboardingFormComponent onSubmit={onSubmitForm} submitting={submitting} />
  );
};

export default OnboardingForm;
